import { render, staticRenderFns } from "./RailsCalendar.vue?vue&type=template&id=b4e07d0c&scoped=true&"
import script from "./RailsCalendar.vue?vue&type=script&lang=js&"
export * from "./RailsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./RailsCalendar.vue?vue&type=style&index=0&id=b4e07d0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e07d0c",
  null
  
)

export default component.exports